import * as generalAPI from '../../../general/api';

export function getTests(params) {
  return generalAPI.getTests({ cloudType: 'rdc', ...params });
}

export function getTestCasesTrends(params) {
  return generalAPI.getTestCasesTrends({ cloudType: 'rdc', ...params });
}
